import type { BuildOrganizationAppPathParams } from '../types';

const buildOrganizationAppPath = ({
    organizationId,
    appSlug,
}: BuildOrganizationAppPathParams): string => `/agents/${organizationId}/apps/${appSlug}`;

export default buildOrganizationAppPath;
